import http from '@/uteis/http/workArea'

export default class WorkAreService {
  async consultarProcessosAReceber (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultarProcessosElaboracao (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/protocolos/setor', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/protocolos/setor', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
